import { render, staticRenderFns } from "./mail-resend.vue?vue&type=template&id=65314c98&scoped=true&"
import script from "./mail-resend.vue?vue&type=script&lang=ts&"
export * from "./mail-resend.vue?vue&type=script&lang=ts&"
import style0 from "./mail-resend.vue?vue&type=style&index=0&id=65314c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65314c98",
  null
  
)

export default component.exports